"use strict";
import RecruitApiClient from "../../RecruitApiClient";
class Api {
  constructor() {
    this.newQuestionTemplate = (params) => RecruitApiClient.post("/api/v4/library_fields", { field: params });
    this.getQuestions = (params) => RecruitApiClient.get("/api/v4/library_fields", params);
    this.deleteQuestion = (id) => RecruitApiClient.delete(`/api/v4/library_fields/${id}`);
    this.updateQuestion = (id, params) => RecruitApiClient.put(`/api/v4/library_fields/${id}`, { field: params });
    this.importQuestions = (params) => RecruitApiClient.post("/api/v4/library_fields/import_fields", params);
    this.validateQuestionName = (params) => RecruitApiClient.get(`/api/v4/library_fields/validate_question_name`, params);
    this.newTag = (params) => RecruitApiClient.post("/api/v4/tags", params);
    this.validateTagName = (params) => RecruitApiClient.get(`/api/v4/tags/validate_tag_name`, params);
    this.updateTag = (id, params) => RecruitApiClient.put(`/api/v4/tags/${id}`, params);
    this.getTags = (params) => RecruitApiClient.get("/api/v4/tags", params);
    this.deleteTag = (id) => RecruitApiClient.delete(`/api/v4/tags/${id}`);
    this.bulkDeleteTags = (params) => RecruitApiClient.post("/api/v4/tags/bulk_delete", params);
    this.mergeTags = (params) => RecruitApiClient.post("/api/v4/tags/merge", params);
    this.saveJobAsTemplate = (params) => RecruitApiClient.post(`/api/v4/job_templates/create_from_job`, params);
    this.getJobTemplates = (params) => RecruitApiClient.get(`/api/v4/job_templates`, params);
    this.deleteJobTemplate = (id) => RecruitApiClient.delete(`/api/v4/job_templates/${id}`);
    this.createJobTemplate = (params) => RecruitApiClient.post(`/api/v4/job_templates`, params);
    this.cloneJobTemplate = (params) => RecruitApiClient.post(`/api/v4/job_templates/clone`, params);
    this.validateJobTemplateName = (params) => RecruitApiClient.get(`/api/v4/job_templates/validate_template_name`, params);
  }
}
export default new Api();
